import React from 'react';

export const CheckboxDefaultIcon = (props) => (
    <svg {...props} width="40" height="40" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="17" y="17" width="22" height="22" rx="3" stroke="#90A0AF" strokeOpacity="0.5" strokeWidth="2" />
    </svg>
);

export default CheckboxDefaultIcon;
